<template>
    <div>
        <v-card class="py-4">
            <div class="pl-5 subtitle-2 primary--text">Schiedsrichter-Ausweise:</div>
            <spieler-rollen-form v-for="(roleItem, i) in spielerRollen.roleForm" :key="i"
                                 :role-item="roleItem" :spieler-rollen="spielerRollen"/>
            <v-alert v-if="!user.permissions.pass" icon="mdi-information" text class="mx-5 mb-2 mt-5">
                Für Änderungen wende dich bitte an den ÖSKB Passreferenten!
            </v-alert>
        </v-card>
        <div v-if="user.permissions.pass"  class="text-right">
            <v-btn color="primary" class="mt-3" @click="spielerRollen.saveRolesFromRoleForm()"
                   :disabled="!spielerRollen.rolesHasBeenChanged() || spielerRollen.isSaved">
                <span v-if="!spielerRollen.isSaved">alle Änderungen speichern</span>
                <span v-else><v-progress-circular size="20" width="3" class="mr-2" indeterminate/>wird gespeichert</span>
            </v-btn>
        </div>
    </div>
</template>

<script>
import {SpielerRollenService} from "@/services/data/spieler/spielerRollen";
import SpielerRollenForm from "@/views/spielerTabelle/spielerInfo/spielerRollenForm";

export default {
    name: "spielerRollen",
    components: {SpielerRollenForm},
    props: ['spieler'],
    data: () => ({
        spielerRollen: null
    }),
    computed: {
        isOpen(){ return this.$route.query.action},
        user(){ return this.$store.state.user },
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            if ( this.spieler ) {
                this.spielerRollen = new SpielerRollenService(this.spieler.roles, true, this.spieler)
            }
        }
    },
    watch: {
        isOpen(to){
            if ( to ) this.init()
        },
    }
}
</script>

<style scoped>

</style>